const escapeHtml = (text: string) =>
  text
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");

const handlePrint = (text: string) => {
  const newWin = window.open("/");

  if (newWin) {
    newWin.document.write(`<pre>${escapeHtml(text)}</pre>`);

    newWin.print();
    newWin.close();
  }
};

export default handlePrint;
